import { useHandleActionItem } from '@/components/hooks/useHandleActionItem';
import { Button } from 'antd';
import React from 'react';
import { CourseTopicProvider } from '../context';
import { CourseTopicTable } from './List/CourseTopicTable';
import { DetailCourseTopic } from './Form';
import { Authorize } from '@/core';
import { PERMISSIONS } from '@/contants';

export const CourseTopicScreen: React.FC<unknown> = () => {
  const { open, handleClose, setOpen, handleClickCreate } = useHandleActionItem();

  return (
    <>
      <CourseTopicProvider>
        <div className='bg-white py-4 px-4 flex flex-col flex-wrap'>
          <div className='ml-auto'>
            <Button
              type='primary'
              size='middle'
              onClick={() => handleClickCreate()}
              className='rounded'
            >
              + Create
            </Button>
          </div>
          <div className='w-full mt-2'>
            <CourseTopicTable />
            <DetailCourseTopic open={open} handleClose={handleClose} setOpen={setOpen} />
          </div>
        </div>
      </CourseTopicProvider>
    </>
  );
};

// export const CourseTopicList = Authorize<unknown>(CourseTopicScreen, PERMISSIONS.COURSE_TOPIC.VIEW);
export const CourseTopicList = CourseTopicScreen;
